export default __webpack_public_path__ + "static/media/p43.2e14ca5c.jpg";